import { useCallback } from 'react'
import { useAuthContext } from '../context/auth'

// Backend Drupi/Fargate (api.social.doer.ar) — distinto del API Gateway de Brands.
// Sirve las vistas de amplificación por marca (/brand-admin/*). Auth: el id_token de
// Cognito crudo en Authorization (el backend lo verifica y saca custom:clientId).
const DRUPI_BASE = process.env.REACT_APP_DRUPI_API_BASE_URL

export const useDrupiApi = () => {
  const { session } = useAuthContext()

  const drupiGet = useCallback(
    async <T,>(path: string): Promise<T> => {
      if (!session?.id_token) throw new Error('unauthenticated')
      if (!DRUPI_BASE) throw new Error('REACT_APP_DRUPI_API_BASE_URL no configurado')

      const res = await fetch(`${DRUPI_BASE}${path}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `${session.id_token}`,
        },
      })
      if (!res.ok) {
        const text = await res.text()
        throw new Error(`Error ${res.status}: ${text}`)
      }
      return res.json()
    },
    [session],
  )

  const drupiPost = useCallback(
    async <T,>(path: string, body?: unknown): Promise<T> => {
      if (!session?.id_token) throw new Error('unauthenticated')
      if (!DRUPI_BASE) throw new Error('REACT_APP_DRUPI_API_BASE_URL no configurado')

      const res = await fetch(`${DRUPI_BASE}${path}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `${session.id_token}`,
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
      })
      if (!res.ok) {
        const text = await res.text()
        throw new Error(`Error ${res.status}: ${text}`)
      }
      return res.json()
    },
    [session],
  )

  return { drupiGet, drupiPost }
}
